import http, { HTTPResultAsync } from '@/utils/http';
import { AnalyticsAppType, analyticsManager } from '@/utils/mixins/analytics';
import { SignUpRequest } from './dto/SignUp';
import { UpdateProfileRequest } from './dto/UpdateProfile';
import { RemoveUserDataRequest } from './dto/RemoveUserData';

export async function removeUserData(payload: RemoveUserDataRequest): HTTPResultAsync {
  return http.sendSafe('DELETE', '/auth/me', payload);
}

export async function signUp(payload: SignUpRequest): HTTPResultAsync {
  return http.sendSafe('POST', '/users', payload);
}

export async function updateProfile(_id: string, payload: UpdateProfileRequest): HTTPResultAsync {
  let result = null;
  if (payload.uploadPicture) {
    const { uploadPicture, removePicture, ...payloadExcluded } = payload;
    result = await http.sendSafe('PUT', `/users/${_id}`, payloadExcluded, undefined, { picture: uploadPicture });
  } else {
    result = await http.sendSafe('PUT', `/users/${_id}`, payload);
  }

  if (result.isOk()) {
    analyticsManager.setUserProfile(AnalyticsAppType.USER, {
      name: payload.firstName,
      custom: {
        Role: payload.designation,
      },
    });
  }

  return result;
}
